import React from 'react'
import PropTypes from 'prop-types'
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import { shuffle } from 'lodash'
import PageTitle from '../features/ui/util/page_title'
import WrappedBundle from '../features/ui/util/wrapped_bundle'
import DefaultLayout from '../layouts/default_layout'
import {
  LIST_TYPE_FEATURED,
  LIST_TYPE_OWN,
  LIST_TYPE_MEMBER_OF,
  LIST_TYPE_SUBSCRIBED_TO,
  SUGGESTION_TYPE_FEEDS,
  BREAKPOINT_EXTRA_SMALL,
} from '../constants'
import { me } from '../initial_state'
import {
  LinkFooter,
  GabAdTopPanel,
  GabAdBottomPanel,
} from '../features/ui/util/async_components'
import { parseQuerystring } from '../utils/querystring'
import RandomSidebarPanels from '../components/sidebar/random_sidebar_panels'
import ShortcutsPanel from '../components/panel/shortcuts_panel'
import ListsSinglePanel from '../components/panel/lists_single_panel'

class ListsPage extends React.PureComponent {

  state = {
    currentTab: LIST_TYPE_FEATURED,
  }

  componentDidMount() {
    this.checkCurrentTab()
  }

  componentDidUpdate(prevProps) {
    if (prevProps.location.key !== this.props.location.key &&
        prevProps.location.pathname === '/feeds' &&
        this.props.location.pathname === '/feeds'
      ) {
      this.checkCurrentTab()
    }
  }

  checkCurrentTab = () => {
    // null/no tab is "featured" aka main landing page of /feeds
    const { tab } = parseQuerystring({ tab: '' })
    this.setState({ currentTab: tab })
  }

  render() {
    const { children, isXS } = this.props
    const { currentTab } = this.state

    const tabs = !!me ? [
      {
        title: 'My Feeds',
        to: `/feeds?tab=${LIST_TYPE_OWN}`,
        active: currentTab === LIST_TYPE_OWN,
      },
      {
        title: 'Member of',
        to: `/feeds?tab=${LIST_TYPE_MEMBER_OF}`,
        active: currentTab === LIST_TYPE_MEMBER_OF,
      },
      {
        title: 'Discover',
        to: `/suggestions?view=${SUGGESTION_TYPE_FEEDS}`,
      },
      {
        title: 'Subscribed to',
        to: `/feeds?tab=${LIST_TYPE_SUBSCRIBED_TO}`,
        active: currentTab === LIST_TYPE_SUBSCRIBED_TO,
      },
      {
        title: 'Featured Feeds',
        to: '/feeds',
        active: !currentTab || currentTab === LIST_TYPE_FEATURED,
      },
    ] : [{
      title: 'Featured Feeds',
      to: '/feeds',
    }]

    const items = RandomSidebarPanels()
    const sidebarLayout = [
      <WrappedBundle key='feed-page-ad-panel' component={GabAdTopPanel} componentParams={{ pageKey: 'feed.sidebar', position: 1 }} />,
      ...shuffle(items),
      LinkFooter,
      <WrappedBundle key='feed-page-ad-panel-bottom' component={GabAdBottomPanel} componentParams={{ pageKey: 'feed.sidebar', position: 1 }} />
    ]

    const actions = isXS ? [
      !!me && {
        attrTitle: 'Create new feed',
        icon: 'add',
        to: '/feeds/create',
      },
      {
        attrTitle: 'Search feeds',
        icon: 'search',
        to: '/search/feeds',
      },
    ].filter(Boolean) : undefined

    const sidebarChildren = [
      <ShortcutsPanel type='list' noPanel />,
      <ListsSinglePanel type={LIST_TYPE_FEATURED} max={20} noPanel padded />,
    ]

    return (
      <DefaultLayout
        showBackBtn
        title='Feeds'
        page='lists'
        button={!!me ? {
          title: 'Create new feed',
          icon: 'add',
          to: '/feeds/create',
        } : undefined}
        search={{
          placeholder: 'Search feeds',
          to: '/search/feeds',
        }}
        actions={actions}
        tabs={tabs}
        layout={sidebarLayout}
        sidebarChildren={sidebarChildren}
      >
        <PageTitle path='Feeds' />
        {children}
      </DefaultLayout>
    )
  }

}

const mapStateToProps = (state) => ({
  isXS: state.getIn(['settings', 'window_dimensions', 'width']) <= BREAKPOINT_EXTRA_SMALL,
})

ListsPage.propTypes = {
  children: PropTypes.node.isRequired,
  dispatch: PropTypes.func.isRequired,
}

export default withRouter(connect(mapStateToProps)(ListsPage))
